import { render, staticRenderFns } from "./ListarAreas.vue?vue&type=template&id=0da670a4&"
import script from "./ListarAreas.vue?vue&type=script&lang=js&"
export * from "./ListarAreas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports